import { Dialog } from '@headlessui/react';
import { useForm } from 'react-hook-form';

import { Modal, Form, Button } from '../base';
import { ErrorOutlineIcon } from '../icons';

interface ExamExitModalProps {
  open: boolean;
  title: string;
  description: string;
  onClose: () => void;
  onExit: () => void;
  disabledCheckBox?: boolean;
  exitText?: string;
}

export default function ExamExitModal({
  open,
  onClose,
  onExit,
  disabledCheckBox = false,
  title,
  description,
  exitText = 'Exit',
}: ExamExitModalProps) {
  const { control, watch, setValue } = useForm<{ examExitConsent: boolean }>({
    defaultValues: { examExitConsent: disabledCheckBox },
  });

  function handleClose() {
    if (!disabledCheckBox) {
      setValue('examExitConsent', false);
    }
    onClose?.();
  }

  return (
    <Modal open={open} onClose={handleClose} className='grid max-w-3xl gap-6'>
      <div className='flex items-center gap-3'>
        <ErrorOutlineIcon className='text-primary text-[40px]' />
        <Dialog.Title as='h3'>{title}</Dialog.Title>
      </div>
      <Dialog.Description>{description}</Dialog.Description>
      {!disabledCheckBox ? (
        <Form.Checkbox control={control} id='exit-exam-consent' name='examExitConsent' required>
          I want to exit, and I know I&apos;ll lose testing time.
        </Form.Checkbox>
      ) : null}
      <div className='flex justify-end gap-2'>
        <Button variant='text' onClick={handleClose}>
          Cancel
        </Button>
        <Button disabled={!watch('examExitConsent')} onClick={onExit}>
          {exitText}
        </Button>
      </div>
    </Modal>
  );
}
